import React, { useState, useEffect } from 'react';
import { getRequest } from '../../../../../utils/httpRequest';
import { t } from "../../../../../utils/i18n";

const CheckBrokerStatus = () => {
  const [brokerStatus, setBrokerStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBrokerStatus = async () => {
      try {
        // Use GET request for fetching broker status
        const response = await getRequest('/api/v1/brokers/check_broker');
        setBrokerStatus(response);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBrokerStatus();
  }, []);

  if (loading) {
    return <div>{t("p2p.common.loading")}</div>;
  }

  if (error) {
    return <div>{t("p2p.common.error_prefix", { message: error })}</div>;
  }

  return (
    <div>
      {brokerStatus.broker_exists &&  brokerStatus.status !== 'approved' ? (
        <div className="broker-status-cont">
          <div className="status-alert-cont">
            <i className="fa fa-info-circle status-icon"></i>
            <h4 className="status-alert-heading">{t("p2p.broker.request_status")}</h4>
            <p>{t("p2p.broker.request_is")} <strong className="status-text">{brokerStatus.status.toUpperCase()}</strong>.</p>
            {brokerStatus.status === 'pending' ? (
              <p>{t("p2p.broker.pending")}</p>
            ) : (
              <></>
            )}
            {brokerStatus.status === 'rejected' ? (
              <p>{t("p2p.broker.rejected")}</p>
            ) : (
              <></>
            )}
            {brokerStatus.status === 'deactivated' ? (
              <p>{t("p2p.broker.deactivated")}</p>
            ) : (
              <></>
            )}
            <br/>
            <a href="/p2p_trades/offers/search?offer_type=buy">
              <button type="button" className="btn broker-status-cancelbtn">{t("p2p.broker.cancel")}</button>
            </a>
          </div>
        </div>
      ) : (
        <></>
      )}

      {!brokerStatus.broker_exists ? (
        <div className="broker-status-cont">
          <div className="status-alert-cont">
            <i className="fa fa-info-circle status-icon"></i>
            <h4 className="status-alert-heading">{t("p2p.broker.not_broker")}</h4>
            <p>{t("p2p.broker.need_broker")}</p>
            <a href="https://www.bananacrystal.com/brokers-application/">
              <button type="button" className="btn broker-status-btn">{t("p2p.broker.become")}</button>
            </a>
            <br/>
            <a href="/p2p_trades/offers/search?offer_type=buy">
              <button type="button" className="btn broker-status-cancelbtn">{t("p2p.broker.cancel")}</button>
            </a>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default CheckBrokerStatus;
